export default {
	title: "Groupes",
	newGroup: "Nouveau groupe",
	editGroup: "Modifier le groupe",
	deleteGroup: "Supprimer le groupe",
	name: "Nom",
	description: "Description",
	color: "Couleur",
	icon: "Icône",
	members: "Membres",
	calendar: "Calendrier",
	assignments: "Activités",
	addMember: "Ajouter un membre",
	removeMember: "Retirer un membre",
	removeMemberConfirm: "Êtes-vous sûr de vouloir retirer ce membre du groupe ?",
	deleteConfirm: "Êtes-vous sûr de vouloir supprimer le groupe \"{name}\" ? Tous les membres seront dissociés et toutes les activités et rappels seront supprimés. Cette action est irréversible.",
	noMembers: "Aucun membre dans ce groupe",
	noMembersText: "Ajoutez des membres pour organiser votre groupe",
	noAssignments: "Aucune activité programmée",
	noAssignmentsText: "Ajoutez une activité via le calendrier",
	selectDayHint: "Sélectionnez un jour pour consulter ou ajouter une activité",
	emptyTitle: "Aucun groupe enregistré",
	emptyText: "Créez des groupes pour organiser les membres de votre temple",
	searchPlaceholder: "Rechercher des groupes...",
	status: {
		active: "Actif",
		inactive: "Inactif",
	},
	filters: {
		status: "Statut",
		active: "Actif",
		inactive: "Inactif",
	},
	assignment: {
		new: "Nouvelle activité",
		edit: "Modifier l'activité",
		delete: "Supprimer l'activité",
		deleteConfirm: "Êtes-vous sûr de vouloir supprimer cette activité ?",
		date: "Date",
		startTime: "Heure",
		description: "Description",
		linkRitual: "Lier à un rituel",
		selectRitual: "Sélectionner un rituel",
		reminder: "Envoyer un rappel par e-mail",
		reminderDays: "Jours avant",
		reminderHintSameDay: "Le jour de l'activité",
		reminderHint1Day: "1 jour avant",
		reminderHintDays: "{days} jours avant",
		reminderMessage: "Message personnalisé",
		reminderMessageHint: "Laissez vide pour utiliser le modèle par défaut",
		addToDay: "Ajouter une activité",
		batchMode: "Jours multiples",
		batchDatesSelected: "{count} date(s) sélectionnée(s)",
		linkFirstRitual: "Lier au premier rituel de chaque jour, si disponible",
	},
	messages: {
		created: "Groupe créé avec succès",
		updated: "Groupe mis à jour avec succès",
		deleted: "Groupe supprimé avec succès",
		memberAdded: "Membre ajouté avec succès",
		memberRemoved: "Membre retiré avec succès",
		assignmentCreated: "Activité créée avec succès",
		assignmentUpdated: "Activité mise à jour avec succès",
		assignmentDeleted: "Activité supprimée avec succès",
		errorLoading: "Erreur lors du chargement des données",
	},
	stats: {
		total: "Total",
		active: "Actifs",
		totalMembers: "Membres",
	},
	validation: {
		nameRequired: "Le nom du groupe est obligatoire",
		nameMaxLength: "Le nom doit comporter au maximum 150 caractères",
	},
	activities: {
		tab: "Activités",
		upcoming: "À venir",
		past: "Passées",
		all: "Toutes",
		linkedToRitual: "Liée à un rituel",
		noActivities: "Aucune activité trouvée",
		noActivitiesUpcoming: "Aucune activité à venir programmée",
		noActivitiesPast: "Aucune activité passée enregistrée",
		showMore: "Charger plus",
	},
	weekDays: {
		sun: "Dim",
		mon: "Lun",
		tue: "Mar",
		wed: "Mer",
		thu: "Jeu",
		fri: "Ven",
		sat: "Sam",
	},
};
